(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-and-after"] && !window.DesignMode) return;
  try {
    
  const carousel_customer_image = new Swiper('.carousel-instance-customer-image', {
    slidesPerView: 1,
    autoplay: {
      speed: 7000,
    },
    navigation: {
      nextEl: '.carousel-next-customer-image',
      prevEl: '.carousel-prev-customer-image',
    },
    pagination: {
      el: '.carousel-pagination-customer-image',
      type: 'bullets',
    },
  });

  const carousel_customer_text = new Swiper('.carousel-instance-customer-text', {
    slidesPerView: 1
  });

  carousel_customer_image.on('activeIndexChange', function() {
    console.log('*** carousel_customer_text.realIndex', carousel_customer_image.realIndex);
    carousel_customer_text.slideTo(carousel_customer_image.realIndex)
  });

  carousel_customer_text.on('activeIndexChange', function() {
    console.log('*** carousel_customer_image.realIndex', carousel_customer_text.realIndex);
    carousel_customer_image.slideTo(carousel_customer_text.realIndex)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefit-cards"] && !window.DesignMode) return;
  try {
    
  const benefitsSwiper = new Swiper('.benefit__card-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 12,
    observer: true,
    navigation: {
      nextEl: '.benefit-next',
      prevEl: '.benefit-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1.75,
        spaceBetween: 20,
      },
    },
    on: {
      observerUpdate: function(){
        console.log('update')
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
  const carousel = new Swiper('.carousel-instance', {
    slidesPerView: 1,
    autoplay: {
      speed: 7000,
    },
    loop: true,
    navigation: {
      nextEl: '.carousel-next',
      prevEl: '.carousel-prev',
    },
    pagination: {
      el: '.carousel-pagination',
      type: 'bullets',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel_2"] && !window.DesignMode) return;
  try {
    
  const carousel = new Swiper('.carousel-instance', {
    slidesPerView: 1,
    autoplay: {
      speed: 7000,
    },
    loop: true,
    navigation: {
      nextEl: '.carousel-next',
      prevEl: '.carousel-prev',
    },
    pagination: {
      el: '.carousel-pagination',
      type: 'bullets',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile dropdowns
  const headerItems = document.querySelectorAll('.footer__mobile-header');
  headerItems.forEach((header) => {
    header.addEventListener('click', (event) => {
      const parent = header.parentElement;
      const content = header.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  // openSearch.addEventListener('click', () => {
  //   if (search.classList.contains('is-visible')) {
  //     search.classList.remove('is-visible');
  //   } else {
  //     search.classList.add('is-visible');
  //   }
  // });

  // closeSearch.addEventListener('click', () => {
  //   search.classList.remove('is-visible');
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"]) return;
  try {
    
  const homepageHero = document.querySelector('.hero.homepage-hero');
  homepageHero.style.height = `${window.innerHeight}px`;

  // const openQuiz = document.querySelector('[data-open-quiz]');
  // if (openQuiz) {
  //   openQuiz.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     document.querySelector('.sticky-footer__button').click();
  //   });
  // }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-dropdowns"] && !window.DesignMode) return;
  try {
    
  const accordionItems = document.querySelectorAll('.image-dropdowns__item-header');
  accordionItems.forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      const parent = accordion.parentElement;
      const content = accordion.nextElementSibling;

      if (!parent.classList.contains('active')) {
        const activeAccordionItem = document.querySelector('.image-dropdowns__item.active');
        const activeContent = activeAccordionItem.querySelector('.image-dropdowns__item-content')
        activeAccordionItem.classList.remove('active');
        slideUp(activeContent, 400);
 
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text"] && !window.DesignMode) return;
  try {
    
  const imageSlider = document.querySelector('.image-text__images');

  // IMPORTANT! If autoplay delay timing is changed,
  // update the animation timing for the progress dots as well
  // in the section-image-text.css file
  if (imageSlider) {
    const imageSwiper = new Swiper(imageSlider, {
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.image-text__progress',
        renderBullet: function (index, className) {
          return `<div class="image-text__bullet-wrapper ${className}" data-slide-id="${index}">
                  <div class="image-text__progress-bar"><div class="image-text__progress-bar-fill"></div></div>
                </div>`;
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-list"] && !window.DesignMode) return;
  try {
    
  const ingredientButtons = document.querySelectorAll('.ingredient-list__button');

  ingredientButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const container = e.target.closest('.ingredient-list');
      const currentActive = container.querySelectorAll('.ingredient-list__block.active');

      const parent = e.target.parentElement;
      const content = document.querySelector(`[data-ingredient='${e.target.dataset.controls}']`);

      currentActive.forEach((active) => {
        active.classList.remove('active');
        if (active.querySelector('.ingredient-list__content')) {
          slideUp(active.querySelector('.ingredient-list__content'), 400);
        }
      });

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        content.classList.remove('active');
        slideUp(parent.querySelector('.ingredient-list__content'), 400);
      } else {
        parent.classList.add('active');
        content.classList.add('active');
        slideDown(parent.querySelector('.ingredient-list__content'), 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-product"]) return;
  try {
    
  document.getElementById('main-clickable-button').addEventListener('click', upsellLogic);

  // TODO: remove?
  async function setCartAttributes(upsell) {
    let cart = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
      },
      body: JSON.stringify({
        attributes: {
          upsell_test: upsell,
        },
      }),
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
    return cart;
  }

  async function setAttributes() {
    upsell_test = getCookie('upsell_test');
    if (upsell_test == 'true') {
      let cart = await setCartAttributes('upsell_active');
    } else if ((upsell_test = 'false')) {
      let cart = setCartAttributes('upsell_inactive');
    } else {
      let cart = setCartAttributes('upsell_not_set');
    }
  }
  setTimeout(() => {
    setAttributes();
  }, 2000);

  function getCookie(cname) {
    // const value = `; ${document.cookie}`;
    // const parts = value.split(`; ${name}=`);
    // if (parts.length === 2) return parts.pop().split(';').shift();

    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  function upsellLogic() {
    if ($('#main-product-handle-id').html().includes('at-home-')) {
      if (getCookie('upsell_test') == 'true') {
        $('#real-submit-button').click();
        // openPopup()
      } else {
        $('#real-submit-button').click();
      }
    } else {
      $('#real-submit-button').click();
    }
  }

  // Main product slider
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
    },
    loop: false,
    pagination: {
      el: '.product__media-pagination',
    },
  });

  const productSliderThumbnails = document.querySelectorAll('.product__media-thumbnail-item');

  productSliderThumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', function (e) {
      e.preventDefault();
      console.log(e.target.dataset.loopPosition);
      productSlider.slideTo(e.target.dataset.loopPosition);
    });
  });

  const accordionItems = document.querySelectorAll('.product__accordion-button');
  accordionItems.forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      const parent = accordion.parentElement;
      const content = accordion.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  let redirect = getCookie('url_redirect')
  if (redirect == 'pdp') {
    $('#formula-picker-direct').show()

    $("p:contains('personalized')").each(function() {
      const updatedText = $(this).text().replace(/personalized/gi, '');
      $(this).text(updatedText);
    });
  }

  let aff_referrer = getCookie('affiliate_referrer')
  let subscription_enabled = (affiliate_config[aff_referrer] ?? {}).pricing?.subscription_enabled ?? true;
  if (!subscription_enabled) {
    $('#quantity-input-id').hide()
  }

  document.getElementById('main-clickable-button').addEventListener("click", upsellLogic);

   async function setCartAttributes(upsell) {
   let cart = await fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
            'attributes': {
              'upsell_test': upsell
            }
        })
    }).then(response => {
      console.log(response)
    })
    .catch(error => {
      console.log(error)
    });
    return cart
  }

  async function setCartAttributesShareasale(affiliate, affiliate_id) {
    if (affiliate_id === undefined || affiliate_id === null) {
      affiliate_id = "none"
    }
   let cart = await fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
            'attributes': {
              'shareasale_affiliate': affiliate,
              'shareasale_affiliate_id': affiliate_id
            }
        })
    }).then(response => {
      console.log(response)
    })
    .catch(error => {
      console.log(error)
    });
    return cart
  }
  
  async function setAttributes() {
      // attribute_dict = { // legacy cart attributes
      //   'redirect_paceline': 'paceline',
      //   'redirect_sweatcoin': 'sweatcoin',
      //   'redirect_ut': 'cactus_media',
      //   'redirect_miles': 'miles',
      //   'redirect_skimm': 'skimm',
      //   'redirect_pinterest': 'pinterest',
      //   'redirect_cpgap': 'redirect_cpgap',
      //   'redirect_cpgap_gen': 'redirect_cpgap_gen'
      // }
    
      upsell_test = getCookie('upsell_test')
    
      // if (upsell_test == 'true') {
      //   let cart = await setCartAttributes("upsell_active"); 
      // } else if (upsell_test = 'false') {
      //   let cart = await setCartAttributes("upsell_inactive"); 
      // } else {
      //   let cart = await setCartAttributes("upsell_not_set"); 
      // }
      let shareasale_cookie = getCookie('shareasaleShopifySSCID')
      let shareasale_cookie_clean = shareasale_cookie ?? "none";
      console.log('shareasale cookie is:')
      console.log(shareasale_cookie_clean)

      var shareasale_cookie_dict = {
        '11k9_lrh8b': 'Skimbit'
      }

      try {
        a_referrer = getCookie('affiliate_referrer')

        if (a_referrer in affiliate_config && 'flow' in affiliate_config[a_referrer] && 'cart_attribute' in affiliate_config[a_referrer]['flow']) {
          if (affiliate_config[a_referrer]['flow']['cart_attribute']) {
            await setCartAttributesShareasale(affiliate_config[a_referrer]['flow']['cart_attribute'], shareasale_cookie_clean);
          } 
        }  
        else {
          if (shareasale_cookie_clean in shareasale_cookie_dict) {
            await setCartAttributesShareasale(shareasale_cookie_dict['shareasale_cookie_clean'], shareasale_cookie_clean); 
          } else {
            await setCartAttributesShareasale("none", shareasale_cookie_clean); 
          }
        }
      } catch (error) {
        console.log(error)

        console.log('something went wrong when setting cart attributes');
      }
  }

  async function clear_cart() {
    await new Promise((resolve, reject) => {
      var xhttp = new XMLHttpRequest();

      xhttp.open("POST", "/cart/clear.js", true);

      xhttp.onreadystatechange = function() {
        if (xhttp.readyState === 4) {
          // Check the HTTP status code
          if (xhttp.status === 200) {
            // Resolve the promise with the response text
            console.log('cart cleared')
            resolve(JSON.parse(xhttp.responseText));
          } else {
            // Reject the promise if there's an error
            console.log('error clearing cart')
            reject(new Error(`Request failed with status ${xhttp.status}`));
          }
        }
      };

      xhttp.send();
    });
  }

  async function cart_setup() {
    await clear_cart()
    await setAttributes()
  }

  cart_setup()
  
  function getCookie(cname) {
    // const value = `; ${document.cookie}`;
    // const parts = value.split(`; ${name}=`);
    // if (parts.length === 2) return parts.pop().split(';').shift();
    
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  function upsellLogic() {
    if ($('#main-product-handle-id').html().includes('at-home-whitening-kit-affiliate-ft')) {
        show_upsell = getCookie('show_upsell')
        if (show_upsell != 'false') {
          openPopup()
        } else {
          $('#real-submit-button').click()
        }
    } else {
      $('#real-submit-button').click()
    }
  }

  // Main product slider
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
    },
    loop: false,
    pagination: {
      el: '.product__media-pagination',
    },
  });

  const productSliderThumbnails = document.querySelectorAll('.product__media-thumbnail-item');

  productSliderThumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', function (e) {
      e.preventDefault();
      console.log(e.target.dataset.loopPosition);
      productSlider.slideTo(e.target.dataset.loopPosition);
    });
  });

  const accordionItems = document.querySelectorAll('.product__accordion-button');
  accordionItems.forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      const parent = accordion.parentElement;
      const content = accordion.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-carousel"] && !window.DesignMode) return;
  try {
    
  const resultsCarouselImageSwiper = new Swiper('.results-carousel__image-swiper', {
    slidesPerView: 1,
    allowTouchMove: false,
  });

  const resultsCarouselControls = document.querySelectorAll('.results-carousel__swiper-button');

  if (resultsCarouselControls) {
    resultsCarouselControls.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (!e.target.classList.contains('active')) {
          document.querySelector('.results-carousel__swiper-button.active').classList.remove('active');
          resultsCarouselImageSwiper.slideTo(e.target.dataset.swiperSlide);
          e.target.classList.add('active');
        }
      });
    });
  }

  const resultsSlider = document.querySelectorAll('.results-carousel__slider');
  resultsSlider.forEach((view) => {
    view.addEventListener('input', function (e) {
      const sliderPosition = e.target.value;
      const slideWrapper = e.target.closest('.results-carousel__image-inner');
      slideWrapper.style.setProperty('--position', `${sliderPosition}%`);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-table"] && !window.DesignMode) return;
  try {
    
  const tableButtons = document.querySelectorAll('[data-table-button]');

  tableButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      const parent = e.target.closest('tr');
      const content = parent.querySelector('.results-table__td:last-of-type');
      const container = e.target.closest('table');

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-footer"]) return;
  try {
    
    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    var keys = {37: 1, 38: 1, 39: 1, 40: 1};

    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }

    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; } 
      }));
    } catch(e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    // call this to Disable
    function disableScroll() {
      window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
      window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
      window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
      window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    function enableScroll() {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
      window.removeEventListener('touchmove', preventDefault, wheelOpt);
      window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    function getCookie(cname) {
    // const value = `; ${document.cookie}`;
    // const parts = value.split(`; ${name}=`);
    // if (parts.length === 2) return parts.pop().split(';').shift();
    
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }
  
  document.querySelector('.sticky-footer__button').addEventListener('click', (e) => {
    e.preventDefault();
    e.target.classList.toggle('hide');
    document.querySelector('.page-transition').classList.toggle('visible');
    quiz_version = getCookie('quiz_version')
    console.log(quiz_version)
    // document.querySelector('.quiz').setAttribute('aria-hidden', false);
    if (quiz_version == 'interactive_v1') {
      document.body.style.overflow = "hidden";
      $('#shopify-section-quiz-2').css('display', 'block')
      $("body").css("background-color","white");
      document.querySelector('.quiz_2').setAttribute('aria-hidden', false);
    } else {
      console.log('preload')
      preload_at_home_whitening_kit() 
      $('#shopify-section-quiz').css('display', 'block')
      document.querySelector('.quiz').setAttribute('aria-hidden', false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    
  const photoToggle = document.querySelectorAll('.testimonial__photo-button');

  photoToggle.forEach((button) => {
    button.addEventListener('click', function (e) {
      const container = e.target.closest('.testimonial__image-wrapper');
      if (container) {
        container.querySelectorAll('.testimonial__image').forEach((b) => {
          b.classList.toggle('active');
        });
      }
    });
  });

  const testimonialImageSwiper = new Swiper('.testimonials__image-swiper', {
    slidesPerView: 1,
    allowTouchMove: false,
  });

  const testimonialContentSwiper = new Swiper('.testimonial__info-swiper', {
    slidesPerView: 1,
    allowTouchMove: false,
    controller: {
      by: 'slide',
      control: testimonialImageSwiper,
    },
  });

  const testimonialControls = document.querySelectorAll('.testimonial__swiper-button');

  if (testimonialControls) {
    testimonialControls.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (!e.target.classList.contains('active')) {
          document.querySelector('.testimonial__swiper-button.active').classList.remove('active');
          testimonialContentSwiper.slideTo(e.target.dataset.swiperSlide);
          e.target.classList.add('active');
        }
      });
    });
  }

  // Mobile dropdowns
  const headerItems = document.querySelectorAll('.testimonial__info-button');
  headerItems.forEach((header) => {
    header.addEventListener('click', (event) => {
      const parent = header.parentElement;
      const content = header.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
